import { addWidthParameter } from "./addWidthParameter";

export const addImage = (images, imageUrl) => {
  if (imageUrl && imageUrl.length) {
    images.push({
      original: addWidthParameter(imageUrl, 1350),
      thumbnail: addWidthParameter(imageUrl, 200),
    });
  }
};